// extracted by mini-css-extract-plugin
module.exports = {"eproHome":"home_eproHome__J9xTx","suffix":"home_suffix__2lDGh","proejctDropdown":"home_proejctDropdown__RSeuP","homeContent":"home_homeContent__1Uc1m","chat":"home_chat__hJAzU"};